/* eslint-disable jsx-a11y/alt-text */
import * as React from 'react'
import { DataGrid } from '@mui/x-data-grid'
import {
  Box,
  Button,
  Chip,
  IconButton,
  Link,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Switch,
  Typography,
} from '@mui/material';
import '../../../src/assets/css/hierarchy.css'
import List from '@mui/material/List';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ListItem from '@mui/material/ListItem';
import { useNavigate } from 'react-router-dom'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { BackArrowIcon, BrochureIcon, GoToLiveIcon, EyeIcon } from '../../icons'
import ThreeDotMenu from '../../components/university-table/ThreeDotMenu'
import { GlobalStyles } from '@mui/material'
import UniversitySummary from '../../components/university-table/UniversitySummary'
import { fetchUniversitiesNames,  fetchUniversityList, updateEnrollment } from '../../api/universityApi'
import { updateTag } from '../../api/tagApi'
import { updateStatus } from '../../api/adminApi'
import { updateFlag } from '../../api/footerApi'
import { handlePreview } from '../../components/CourseDetails/CourseDetailsForm'
import CommonFilterTab from '../../components/common/CommonFilterTab'
import CommonTableFormat from '../../components/common/CommonTableFormat'
import Tooltip from '@mui/material/Tooltip';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import CommonDataTable from '../../components/common/CommonDataTable';
import { defaultPaginationValues, enrollmentOptions, filterType, filterTypeOptions, normalStatusList, tagOptions, toogleOptions, universityTypeList } from '../../utils/constant';
import { useSelector } from 'react-redux';
import { formatMultiQueryParams, jsonParserFormatter } from '../../utils/helperFunction';
import ExpandRowTable from '../../components/common/ExpandRowTable';
import { useDispatch } from 'react-redux';
import { setFilterField } from '../filter-container/reducer/filterSlice';


const UniversityDataTable = ({ isHandlBtn = false, rowId }) => {
  const dispatch = useDispatch()
  const filterSlice = useSelector(state=>state.filter?.filters)
  const LOCATION_FILTER = `filters:${window.location.pathname}`
  const [rows, setRows] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const navigate = useNavigate()
  const [selectedStatus, setSelectedStatus] = React.useState('')
  const [searchFilter, setSearchFilter] = React.useState({})
  const [rowCount, setRowCount] = React.useState(0);
  const [universitySuggestion,setUniversitySuggesion] = React.useState([])
  const [pageFilters, setPageFilters] =  React.useState(defaultPaginationValues);
  const [isRender,setIsRender] = React.useState(false)
 
  const handleChange = async (id, field, value) => {
    if (field === 'action') {
      if (value === 'View') {
        const universityId = rows.find(r => r.id === id)?.universityId || '';
        navigate(`/university-listing-management/university-details/${universityId}`, {
          state: { viewOnly: true, source: 'ActionMenu' }
        });
        return;
      }

      if (value === 'Send to draft') {
        const prevStatus = rows.find(r => r.id === id)?.status || '';
        setRows(prev => prev.map(r => r.id === id ? { ...r, status: 'Draft' } : r));
        try {
          await updateStatus({
            id,
            status: 'draft',
            type: 'university',
          });
        } catch (err) {
          setRows(prev => prev.map(r => r.id === id ? { ...r, status: prevStatus } : r));
        }
        return;
      }
      return;
    }

    setRows(prev =>
      prev.map(row => (row.id === id ? { ...row, [field]: value } : row))
    );

    if (field === 'tag') {
      try {
        await updateTag({ id, tag: value, type: 'university' });
      } catch (err) {
        setRows(prev =>
          prev.map(row =>
            row.id === id
              ? { ...row, tag: prev.find(r => r.id === id)?.tag || '' }
              : row
          )
        );
      }
    } else if (field === 'enrollment') {
      try {
        await updateEnrollment({ id, status: value, type: 'university' });
      } catch (err) {
        setRows(prev =>
          prev.map(row =>
            row.id === id
              ? { ...row, enrollment: prev.find(r => r.id === id)?.enrollment || '' }
              : row
          )
        );
      }
    }
  };

  function getStatusClass(status) {
    switch (status) {
      case 'Live':
        return 'status-live'
      case 'Draft':
        return 'status-draft'
      case 'Pending':
        return 'status-pending'
      case 'Deactivated':
        return 'status-deactivated'
      default:
        return ''
    }
  }
  const requestActionColumn = {
    field: 'requestAction',
    headerName: 'Request Action',
    width: 200,
    filterable:false,
    renderCell: (params) =>
      loading ? (
        <Box className='d-flex gap-4'>
          <Skeleton width={70} />
          <Skeleton width={70} />
        </Box>
      ) : params.row.status === 'Pending' ? (
        <Box className='d-flex gap-1 h-100 align-items-center'>
          <Button
            sx={{
              background: '#098B34',
              fontSize: '12px',
              textTransform: 'capitalize',
              fontWeight: 400,
              color: '#fff',
              width: '87px',
              padding: '3px 0',
              borderRadius: '20px',
              '&:hover': {
                background: '#066b2b',
              },
            }}
          >
            Approve
          </Button>
          <Button
            sx={{
              background: '#C3371B',
              fontSize: '12px',
              textTransform: 'capitalize',
              fontWeight: 400,
              color: '#fff',
              width: '87px',
              padding: '3px 0',
              borderRadius: '20px',
              '&:hover': {
                background: '#a62a14',
              },
            }}
          >
            Reject
          </Button>
        </Box>
      ) : (
        <Box sx={{ fontSize: '13px', color: '#6b7280' }}>—</Box>
      ),
  }


  const draftActionColumn = {
    field: 'DraftrequestAction',
    headerName: 'Request Action',
    width: 200,
    filterable:false,
    renderCell: (params) =>
      loading ? (
        <Box className='d-flex gap-4'>
          <Skeleton width={70} />
          <Skeleton width={70} />
        </Box>
      ) : params.row.status === 'Draft' ? (
        <Box className='d-flex gap-1 h-100 align-items-center'>
          <Button
            sx={{
              background: '#098B34',
              fontSize: '12px',
              textTransform: 'capitalize',
              fontWeight: 400,
              color: '#fff',
              width: '87px',
              padding: '3px 0',
              borderRadius: '20px',
              '&:hover': {
                background: '#066b2b',
              },
            }}
          >
            Publish
          </Button>
          <Button
            sx={{
              background: '#1075FF',
              fontSize: '12px',
              textTransform: 'capitalize',
              fontWeight: 400,
              color: '#fff',
              width: '126px',
              padding: '3px 0',
              borderRadius: '20px',
              '&:hover': {
                background: '#0a63e1',
              },
            }}
          >
            Ready for Live
          </Button>
        </Box>
      ) : (
        <Box sx={{ fontSize: '13px', color: '#6b7280' }}>—</Box>
      ),
  }


  const columns = [
    {
      field: 'sNo',
      headerName: 'S. No.',
      width: 60, // keep fixed, small number
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      // renderCell: (params) => rows.findIndex((r) => r.id === params.row.id) + 1,
    },
    {
      field: 'universityId',
      headerName: 'University ID',
      flex: 1,
      minWidth: 130,
      cellClassName: 'sticky-col-1',
      headerClassName: 'sticky-col-1',
      filterColumnName:"universityId",
      filterType:filterTypeOptions.string,
    },
    {
      field: 'name',
      headerName: 'University',
      flex: 2,
      minWidth: 220,
      filterColumnName:"universityName",
      filterType:filterTypeOptions.selection,
      selection:universitySuggestion,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={150} />
        ) : (
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              component="img"
              src={params.row.logo}
              alt="logo"
              sx={{
                width: 40,
                height: 40,
                padding: '5px',
                borderRadius: '50%',
                objectFit: 'contain',
                backgroundColor: '#fff',
                boxShadow: '0 1px 4px rgba(0, 0, 0, 0.15)',
                display: 'block',
                maxHeight: 60,
              }}
            />
            {params.value}
            <Tooltip title="View University List" arrow>
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  cursor: 'pointer'
                }}
                onClick={() =>
                  navigate(`/university-listing-management/university-details/${params.row.universityId}`)
                }
              >
                <EyeIcon sx={{ color: "#363853", fontSize: "20px" }} />
              </Box>
            </Tooltip>
          </Box>
        ),
    },

    // Conditionally include Courses & Specializations only if not Pending or Draft
    ...(selectedStatus !== 'Pending' && selectedStatus !== 'Draft'
      ? [
        {
          field: 'courseCount',
          headerName: 'Courses',
          flex: 1,
          minWidth: 200,
          filterColumnName:"courseCount",
          filterType:filterTypeOptions.numberRange,
          children: (col,row)=> <ExpandRowTable row={row} col={col}/>,
          renderCell: ({ row, toggleExpand, isExpanded }) => {
            return (
              <>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                    gap: "12px",
                    cursor: "pointer",
                    position: "relative",
                  }}
                >
                  <Chip
                    sx={{ background: "#DFEDFF", color: "#363853" }}
                     onClick={() =>
                        navigate(`/university-listing-management/variant-course/${row.id}`)
                      }
                    label={row.courseCount}
                  />

                  <Tooltip title="View Course List" arrow>
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={() =>
                        navigate(`/university-listing-management/variant-course/${row.id}`)
                      }
                    >
                      <EyeIcon sx={{ color: "#363853", fontSize: "20px" }} />
                    </Box>
                  </Tooltip>

                  <Tooltip title="View More Details" arrow>
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={toggleExpand}
                    >
                      <ExpandCircleDownIcon
                        sx={{
                          color: isExpanded ? "#1976d2" : "#24ad24",
                          transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "0.3s ease",
                        }}
                      />
                    </Box>
                  </Tooltip>
                </Box>
              </>

            );
          },
        },
        {
          field: 'specializationCount',
          headerName: 'Specializations',
          flex: 1,
          minWidth: 130,
          filterColumnName:"specializationCount",
          filterType:filterTypeOptions.numberRange,
          renderCell: (params) =>
            loading ? (
              <Skeleton width={40} />
            ) : (
              <Chip 
              onClick={() => navigate(`/university-listing-management/variant-specialization/${params?.row?.id}`)}
              label={params.value} 
              sx={{ background: '#DFEDFF', color: '#363853' }} />
            ),
        },
      ]
      : []),
    {
      field: 'gotoLive',
      headerName: selectedStatus === 'Pending' || selectedStatus === 'Draft' ? 'Preview' : 'Go to Live',
      width: 100, // fixed because icon button
      filterable:false,
      renderCell: (params) =>
        loading ? (
          <Skeleton variant="circular" width={24} height={24} />
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', height: '100%' }}>
            <IconButton color="primary"
              onClick={() => handlePreview(params?.row?.id, 'university')}
            >
              <GoToLiveIcon />
            </IconButton>
          </Box>
        ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 130,
      filterColumnName:"status",
      filterType:filterTypeOptions.selection,
      selection:normalStatusList,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={70} />
        ) : (
          <Chip
            label={params.value}
            size="small"
            icon={
              <FiberManualRecordIcon
                className={getStatusClass(params.value)}
                sx={{
                  fontSize: 10,
                  color: getStatusColor(params.value),
                }}
              />
            }
            sx={{
              bgcolor: getStatusBgColor(params.value),
              color: getStatusTextColor(params.value),
              fontWeight: 500,
            }}
          />
        ),
    },

    // Conditionally include request action columns based on status
    ...(selectedStatus === 'Pending' ? [requestActionColumn] : []),
    ...(selectedStatus === 'Draft' ? [draftActionColumn] : []),

    {
      field: 'tag',
      headerName: 'Tag',
      flex: 1,
      minWidth: 180,
      filterColumnName:"tag",
      filterType:filterTypeOptions.selection,
      selection:tagOptions,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={100} />
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', height: '100%' }}>
            <Select
              value={params.value}
              onChange={(e) => handleChange(params.row.id, 'tag', e.target.value)}
              size="small"
              disabled={selectedStatus === 'Deactivated'}
              fullWidth
              IconComponent={KeyboardArrowDownIcon}
              sx={{
                borderRadius: '50px',
                fontSize: '13px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '50px',
                },
                '& .MuiSelect-select': {
                  paddingY: '8px',
                  display: 'flex',
                  alignItems: 'center',
                },
              }}
            >
              {tagOptions.map((tag) => (
                <MenuItem key={tag.value} value={tag.value}>
                  <Box display="flex" alignItems="center" gap={1} sx={{ fontSize: '13px' }}>
                    {tag.icon}
                    {tag.label}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </Box>
        ),
    },
    {
      field: 'enrollment',
      headerName: 'Enrollment Window',
      flex: 1,
      minWidth: 180,
      filterColumnName:"enrollmentWindow",
      filterType:filterTypeOptions.selection,
      selection:enrollmentOptions,
      renderCell: (params) =>
        loading ? (
          <Skeleton width={120} />
        ) : (
          <Select
            value={params.value}
            onChange={(e) => handleChange(params.row.id, 'enrollment', e.target.value)}
            size="small"
            fullWidth
            disabled={selectedStatus === 'Deactivated'}
            IconComponent={KeyboardArrowDownIcon}
            sx={{
              borderRadius: '50px',
              fontSize: '13px',
              '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: '50px',
              },
            }}
          >
            {enrollmentOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                <Box display="flex" alignItems="center" gap={1} sx={{ fontSize: '13px' }}>
                  <FiberManualRecordIcon
                    sx={{
                      fontSize: 10,
                      color: opt.color,
                    }}
                  />
                  {opt.label}
                </Box>
              </MenuItem>
            ))}
          </Select>
        ),
    },
    {
      field: 'isFooter',
      headerName: 'Footer',
      flex: 1,
      minWidth: 120,
      filterColumnName:"isFooter",
      filterType:filterTypeOptions.selection,
      selection:toogleOptions,
      renderCell: (params) => {
        return loading ? (
          <Skeleton width={40} />
        ) : (
          <Switch
            checked={Boolean(params?.value)}
            defaultChecked={Boolean(params?.value)}
            onChange={(e) => handleToggle(params.id, e.target.checked, 'university', 'isFooter')}
            color="primary"
            size="small"
          />
        );
      }
    },
    {
      field: 'isHomeVisible',
      headerName: 'Home Page',
      flex: 1,
      minWidth: 120,
      filterColumnName:"isHomeVisible",
      filterType:filterTypeOptions.selection,
      selection:toogleOptions,
      renderCell: (params) => {
        return loading ? (
          <Skeleton width={40} />
        ) : (
          <>
            <Switch
              checked={Boolean(params?.value)}
              defaultChecked={Boolean(params?.value)}
              onChange={(e) => handleToggle(params.id, e.target.checked, 'university', 'isHomeVisible')}
              color="primary"
              size="small"
            />
          </>
        );
      }
    },
    { 
      field: 'createdDate',
       filterColumnName:"createdAt",
      filterType:filterTypeOptions.dateRange,
      maxDate:new Date(),
      headerName: 'Created Date', 
      flex: 1, 
      minWidth: 130, 
    },
    { field: 'lastUpdate', 
      headerName: 'Last Update', 
      flex: 1, 
      minWidth: 130,
      filterColumnName:"updatedAt",
      filterType:filterTypeOptions.dateRange,  
      maxDate:new Date(),
    },
    { field: 'contactEmail',
       headerName: 'Contact Email', 
       flex: 1, 
       minWidth: 180,
       filterColumnName:"contactEmail",
       filterType:filterTypeOptions.string,   
      },
    { field: 'phone', 
      headerName: 'Phone', 
      flex: 1, 
      minWidth: 150,
      filterColumnName:"telephoneNumber",
       filterType:filterTypeOptions.string, 
    },
    { field: 'studentHelpline',
       headerName: 'Student Helpline', 
       flex: 1, 
       minWidth: 150 ,
      filterColumnName:"studentSupportLine",
       filterType:filterTypeOptions.string, 
      },
    { 
      field: 'aliasShortName', 
      headerName: 'Alias / Short Name', 
      flex: 1, 
      minWidth: 150,
      filterColumnName:"shortName",
       filterType:filterTypeOptions.string,  
    },
    {
      field: 'website',
      headerName: 'Website',
      flex: 1,
      minWidth: 180,
      filterColumnName:"websiteLink",
      filterType:filterTypeOptions.string, 
      renderCell: (params) =>
        loading ? (
          <Skeleton width={150} />
        ) : (
          <Link href={params.value} target="_blank" underline="hover" sx={{ color: '#0463EF' }}>
            {params.value}
          </Link>
        ),
    },
    { field: 'foundedYear',
       headerName: 'Founded Year', 
       flex: 1, 
       minWidth: 150,
      filterColumnName:"yearEstablished",
      filterType:filterTypeOptions.string, 
       },
    { field: 'type', 
      headerName: 'Type', 
      flex: 1, 
      minWidth: 150,
      filterColumnName:"institutionType",
      filterType:filterTypeOptions.selection, 
      selection:universityTypeList
     },
    // { field: 'accreditatedBy', headerName: 'Accreditated By', flex: 1, minWidth: 150 },
    { field: 'location', 
      headerName: 'Location', 
      flex: 1, 
      minWidth: 150,
      filterColumnName:"state",
      filterType:filterTypeOptions.string,  
    },
    {
      field: 'brochure',
      headerName: 'Brochure',
      filterable:false,
      width: 100,
      renderCell: (params) => {
        const brochureUrl = params?.row?.brochure?.url;
        return loading ? (
          <Skeleton variant="circular" width={24} height={24} />
        ) : (
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', height: '100%' }}>
            <IconButton
              color="primary"
              onClick={() => {
                if (brochureUrl) {
                  window.open(brochureUrl, '_blank', 'noopener,noreferrer');
                }
              }}
            >
              <BrochureIcon />
            </IconButton>
          </Box>
        );
      },
    },
    // { field: 'campusImages', headerName: 'Campus Images', flex: 1, minWidth: 130 },
    {
      field: 'completion',
      headerName: 'Completion',
      flex: 1,
      minWidth: 100,
      filterColumnName:"completionPercentage",
      filterType:filterTypeOptions.string, 
      renderCell: (params) => (
        <Box
          sx={{
            color:
              params.value >= 80 ? '#22c55e' : params.value >= 50 ? '#f59e0b' : '#098B34',
            fontWeight: 500,
            fontSize: '13px',
          }}
        >
          {params.value}%
        </Box>
      ),
    },
    {
      field: 'action',
      headerName: 'Action',
      filterable:false,
      width: 140, // fixed for ThreeDotMenu button
      renderCell: (params) =>
        loading ? <Skeleton width={80} /> : <ThreeDotMenu rowId={params.row.id} onAction={handleChange} />,
    },
    // {
    //   field: 'socialLinks',
    //   headerName: 'Social Media',
    //   flex: 2,
    //   minWidth: 200,
    //   renderCell: (params) =>
    //     loading ? (
    //       <Skeleton width={150} />
    //     ) : params.value && Array.isArray(params.value) && params.value.length > 0 ? (
    //       <Box display="flex" flexWrap="wrap" gap={0.5}>
    //         {params.value.map((link, i) => (
    //           <Link
    //             key={i}
    //             href={link}
    //             target="_blank"
    //             rel="noopener noreferrer"
    //             underline="hover"
    //             sx={{ color: '#0463EF', textDecoration: 'underline' }}
    //           >
    //             {link}
    //           </Link>
    //         ))}
    //       </Box>
    //     ) : null
    // }
  ]

  const handleFliterSliceChange = (values = {},isReset=false) => {
    let isQuery = typeof values === "object" && Object.keys(values)?.length
    isQuery && dispatch(setFilterField({ pathname: LOCATION_FILTER, filters: JSON.stringify({ ...(isReset ? {} : pageFilters), ...defaultPaginationValues, ...values }) }))
  }

const fetchUniversityListDetails = () => {
    setLoading(true)
    const multiFilter = formatMultiQueryParams(filterSlice[LOCATION_FILTER])
    fetchUniversityList(setRows, {...searchFilter,...multiFilter,isMultiFilter:true }, false, false, setRowCount)
      .finally(() => setLoading(false))
  }

const fetchUniversitySuggestionList = () => {
    fetchUniversitiesNames((result)=>setUniversitySuggesion(result?.map(item=>({...item,value:item?.label}))))
    .catch(err=>console.log("error:---",err))
  }

  // initial load or when filter slice change
  React.useEffect(() => {
    fetchUniversityListDetails()
  }, [filterSlice[LOCATION_FILTER],isRender])

  // handle extra filter tabs changes
  React.useEffect(()=>{
    if(pageFilters?.page){
      handleFliterSliceChange({page:0})
    }else{
      setIsRender(!isRender)
    }
  },[searchFilter])

  // parse page filters
   React.useEffect(() => {
    const values = jsonParserFormatter(filterSlice[LOCATION_FILTER])
    setPageFilters(values)
  }, [filterSlice[LOCATION_FILTER]])

  // initial load
  React.useEffect(()=>{
    fetchUniversitySuggestionList()
  },[])

  function getStatusBgColor(status) {
    switch (status) {
      case 'Live':
        return '#fff'
      case 'Draft':
        return '#fff'
      case 'Pending':
        return '#fff'
      case 'Deactivated':
        return '#fff'
      default:
        return '#fff'
    }
  }

  function getStatusTextColor(status) {
    switch (status) {
      case 'Live':
        return '#363853' // darker green
      case 'Draft':
        return '#363853' // darker gray
      case 'Pending':
        return '#363853' // darker orange
      case 'Deactivated':
        return '#363853' // darker red
      default:
        return '#666'
    }
  }

  function getStatusColor(status) {
    switch (status) {
      case 'Live':
        return '#22c55e' // green
      case 'Draft':
        return '#64748b' // grayish
      case 'Pending':
        return '#f97316' // orange
      case 'Deactivated':
        return '#ef4444' // red
      default:
        return '#999'
    }
  }

  const handleToggle = (id, newValue, type, flagType) => {
    updateFlag({ id, isFooter: newValue, type, flagType })
      .catch(() => {
        setRows((prev) =>
          prev.map((row) =>
            row.id === id ? { ...row, [flagType]: !newValue } : row
          )
        );
      });

    setRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [flagType]: newValue } : row
      )
    );
  };

  return (
    <>
      {/* Apply global styles to DataGrid dropdown menus */}
      {/* <GlobalStyles
        styles={{
          '.MuiDataGrid-menuList': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiDataGrid-panelContent': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiSelect-select': {
            fontSize: '13px',
            padding: '4px 0',
          },
          '.MuiList-root .MuiButtonBase-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-panelContent .MuiOutlinedInput-input': {
            fontSize: '13px',
          },
          '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root .MuiFormControlLabel-label': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiTypography-root': {
            fontSize: '13px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root': {
            fontSize: '13px',
            padding: '6px 12px',
          },
          '.MuiDataGrid-menuList .MuiMenuItem-root:hover': {
            backgroundColor: '#f5f5f5',
          },
          '& .MuiDataGrid-columnHeaders': {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            backgroundColor: '#fff',
          },
          '& .MuiDataGrid-cell.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 2,
          },
          '& .MuiDataGrid-columnHeader.sticky-col-1': {
            position: 'sticky',
            left: 0,
            background: '#fff',
            zIndex: 3, // slightly higher than cell
          },
        }}
      /> */}

      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div className="page-header" style={{ position: 'sticky', top: '4.5rem', zIndex: '9', padding: '10px 15px', borderBottom: '1px solid #E6E7E8', background: '#fff', }}>
          <div className="row align-items-center">
            <div className="col">
              <Typography sx={{ fontSize: '18px', fontWeight: '600', color: '#15243E', display: 'flex', alignItems: 'center', gap: 1, }}><Link href="/" className='d-flex'><BackArrowIcon /></Link>University Listing Management </Typography>
            </div>
            {/* End Col */}
            {isHandlBtn && (<div className="col">  <Box display="flex" gap={2} sx={{ justifyContent: 'end', }}>

              <Button onClick={() => navigate('/university-listing-management/university-details')} sx={{ background: '#0463EF', color: '#fff', minHeight: 'auto', padding: '4px 15px', fontSize: '14px', textTransform: 'capitalize', }}>
                Add University
              </Button>
            </Box></div>)}
          </div>
          {/* End Col */}
        </div>
        <UniversitySummary type="university" isAdmin={true} />
        {/* Filter Toolbar */}
        <CommonFilterTab type="university" module={"admin"}  detailType='University Details' searchPlaceholder='Search university...' fetchList={setSearchFilter} showCount=
        {rows?.length} 
        rowCount={rowCount} />

        <CommonDataTable columns={columns} rows={rows} idKey="field" loading={loading} filterEnabled={true} rowCount={rowCount}
        handleFilterApply={()=>{}}
        pageFilters={pageFilters}
        handleFliterSliceChange={handleFliterSliceChange}
        />
      </Box>
    </>
  )
}

export default UniversityDataTable
